import Base from '../core/Base';
import { request, MODULES } from '../core/Api';

class Iban extends Base {
  constructor(props) {
    super(props);

    this.config = {
      selector: '.js-iban',
      variantA: '.js-iban-variant-a',
      variantB: '.js-iban-variant-b',
      ibanInput: '.js-iban-input',
      defaultInput: '.js-iban-default',
      countrycode: '.js-iban-countrycode',
      checkDigitsInput: '.js-iban-checkdigits',
      bankCodeInput: '.js-iban-bankcode',
      accountNumberInput: '.js-iban-accountnumber',
      ibanValidationMessage: '[data-valmsg-for="iban"]',
      inputValidClass: 'valid',
      inputInvalidClass: 'input-validation-error',
      fieldValidClass: 'field-validation-valid',
      fieldInvalidClass: 'field-validation-error',
      hiddenClass: 'iban-hide',
      regexIban: new RegExp('[(nl|Nl|nL|NL)]{2}\\d{2}[a-z|A-Z]{4}\\d{10}'),
      regexNumbers: new RegExp('\\d{3,10}'),
    };
    this.state = {
      checkDigits: '',
      bankCode: '',
      accountNumber: '',
    };

    // Expose toggle functions to window
    window.showIbanA = () => this.showVariant(this, 'A');
    window.showIbanB = () => this.showVariant(this, 'B');
  }

  init() {
    const selector = document.querySelectorAll(this.config.selector);
    const validator = $('form').data('validator');

    // Disable validation on the fake inputs
    if (validator) {
      validator.settings.ignore += ', #iban-checkdigits, #iban-bankcode, #iban-accountnumber, #iban-default';
    }

    // Check if this component is unique
    if (this.isUnique(selector)) {
      this.setState(
        {
          selector: selector[0],
          validator,
        },
        () => this.selectElements()
      );
    }
  }

  selectElements() {
    // Selecting DOM elements
    this.setState(
      {
        variantA: this.state.selector.querySelector(this.config.variantA),
        variantB: this.state.selector.querySelector(this.config.variantB),
        ibanInput: this.state.selector.querySelector(this.config.ibanInput),
        defaultInput: this.state.selector.querySelector(this.config.defaultInput),
        countrycode: this.state.selector.querySelector(this.config.countrycode),
        checkDigitsInput: this.state.selector.querySelector(this.config.checkDigitsInput),
        bankCodeInput: this.state.selector.querySelector(this.config.bankCodeInput),
        accountNumberInput: this.state.selector.querySelector(this.config.accountNumberInput),
        ibanValidationMessage: this.state.selector.querySelector(this.config.ibanValidationMessage),
      },
      () => {
        this.setEventListeners();
        this.getInitialValues();
        if (this.state.ibanInput.value.length > 0) {
          this.handleFetchRequest();
        }
      }
    );
  }

  getInitialValues() {
    // Getting the first value of the select, and set it as bankCode value in the state
    this.setState(
      {
        countrycode: '',
        checkDigits: this.state.checkDigitsInput.value,
        bankCode: this.state.bankCodeInput[0].value,
        accountNumber: this.state.accountNumberInput.value,
        defaultValue: this.state.defaultInput.value,
      },
      () => this.updateValue()
    );
  }

  setEventListeners() {
    // Checkdigits keyup listener, updates the state
    this.state.checkDigitsInput.addEventListener('keyup', () => {
      this.setState(
        {
          countrycode: 'NL',
          checkDigits: this.state.checkDigitsInput.value,
        },
        () => this.updateValue()
      );
    });

    // Bankcode keyup listener, updates the state or shows the default
    this.state.bankCodeInput.addEventListener('change', event => {
      if (event.target.value === 'default') {
        this.showVariant(this, 'B');
      } else {
        this.setState(
          {
            countrycode: 'NL',
            bankCode: this.state.bankCodeInput.value,
          },
          () => this.updateValue()
        );
      }
    });

    // Accountnumber keyup listener, updates the state
    this.state.accountNumberInput.addEventListener('keyup', () => {
      this.setState(
        {
          countrycode: 'NL',
          accountNumber: this.state.accountNumberInput.value,
        },
        () => this.updateValue()
      );
    });

    // Default keyup listener
    this.state.defaultInput.addEventListener('keyup', () => {
      this.state.defaultValue = this.state.defaultInput.value;
      this.updateValue();
    });

    // Blur on inputs
    this.state.checkDigitsInput.addEventListener('blur', () => this.shouldValidate());
    this.state.bankCodeInput.addEventListener('blur', () => this.shouldValidate());
    this.state.accountNumberInput.addEventListener('blur', () => this.shouldValidate());

    // Default input blur
    this.state.defaultInput.addEventListener('blur', () => this.handleDefaultInputBlur());
  }

  updateValue() {
    // Update the actual iban input value
    const { countrycode, checkDigits, bankCode, accountNumber, defaultValue } = this.state;

    if (defaultValue.length > 0) {
      this.state.ibanInput.value = defaultValue;
    } else {
      this.state.ibanInput.value = `${countrycode}${checkDigits}${bankCode}${accountNumber}`;
    }
  }

  shouldValidate() {
    // Handle when to do the fetch request on blur for the 3 iban inputs
    const { checkDigits, bankCode, accountNumber } = this.state;

    this.setState(
      {
        countrycode: 'NL',
      },
      () => {
        if ((checkDigits.length > 0 && bankCode.length > 0 && accountNumber.length > 0) || (bankCode.length > 0 && accountNumber.length > 3) || (checkDigits.length > 0 && accountNumber.length > 3)) {
          this.handleFetchRequest();
        }
      }
    );
  }

  handleDefaultInputBlur() {
    // Handle when to do the fetch request for the single iban input
    if (!this.state.defaultInput.classList.contains(this.config.hiddenClass)) {
      // if (this.config.regexNumbers.test(this.state.defaultInput.value)) {
        // disabled on request of GDL, if this is permenatly then remove the whole handler
        // return this.handleFetchRequest();
      // }
      return this.triggerValidation();
    }
  }

  handleFetchRequest() {
    // Check or convert the inputted value
    const iban = this.state.ibanInput.value.toUpperCase();

    function responseInvalid(self) {
      self.state.ibanInput.classList.add(self.config.inputInvalidClass);
      self.state.ibanValidationMessage.classList.remove(self.config.fieldValidClass);
      self.state.ibanValidationMessage.classList.add(self.config.fieldInvalidClass);
      self.state.ibanValidationMessage.innerHTML = `<span id="iban-error" class>${self.state.ibanInput.getAttribute('data-val-regex')}</span>`;
    }

    function responseValid(response, self) {
      const data = JSON.parse(response);
      if (data.converted) {
        if (data.notConvertedMessage) {
          responseInvalid();
        } else {
          self.state.defaultInput.value = data.iban;
          self.state.defaultValue = data.iban;
          self.state.ibanInput.value = data.iban;
          self.triggerValidation();
        }
      } else {
        responseInvalid();
      }
    }

    request(MODULES.iban, this.props.token, { iban })
      .then(response => {
        responseValid(response, this);
      })
      .catch(() => {
        responseInvalid(this);
      });
  }

  triggerValidation() {
    // Trigger a focus and blur that will trigger validation on the input.
    this.state.validator.settings.ignore = ':hidden, #iban-checkdigits, #iban-bankcode, #iban-accountnumber, #iban-default';
    this.state.ibanInput.focus();
    this.state.ibanInput.blur();
    this.state.validator.settings.ignore = ':hidden, #iban-checkdigits, #iban-bankcode, #iban-accountnumber, #iban-default';
  }

  showVariant(self, variant) {
    // Resetting the state
    self.setState({
      checkDigits: '',
      bankCode: '',
      accountNumber: '',
      defaultValue: '',
    });

    // Empty all inputs
    self.state.defaultInput.value = '';
    self.state.ibanInput.value = '';
    self.state.checkDigitsInput.value = '';
    self.state.accountNumberInput.value = '';

    // Removing the real iban input validation classes
    self.state.ibanInput.classList.remove(self.config.inputValidClass);
    self.state.ibanInput.classList.remove(self.config.inputInvalidClass);
    self.state.ibanValidationMessage.classList.remove(self.config.fieldInvalidClass);
    self.state.ibanValidationMessage.innerHTML = '';

    // Show the chosen variant
    if (variant === 'A') {
      self.state.variantA.classList.remove(self.config.hiddenClass);
      self.state.variantB.classList.add(self.config.hiddenClass);
      self.getInitialBankCode();
    } else {
      self.state.variantB.classList.remove(self.config.hiddenClass);
      self.state.variantA.classList.add(self.config.hiddenClass);
    }
  }
}

export default Iban;
